import { render, staticRenderFns } from "./MultiplaEscolha.vue?vue&type=template&id=eb1e2178&"
import script from "./MultiplaEscolha.vue?vue&type=script&lang=js&"
export * from "./MultiplaEscolha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports